<template>
  <bm-overlay ref="customOverlay" class="sample" pane="labelPane" @draw="draw">
    <div class="mapGo">
      <div>
        <div class="parkName pbNum">{{ shopInfo.name }}</div>
        <div class="pbNum">距您{{ shopInfo.cdistance }}</div>
        <div class="pbNum" style="font-size: 16px">
          剩余车位：{{ shopInfo.remain_park_num }}/{{ shopInfo.total_park_num }}
        </div>
      </div>
      <!-- <img class="parkIcon" src="https://www.urbanservices.cn/Map/static/go.png" alt=""/> -->
    </div>
    <div class="pbNum" v-if="shopInfo.parkingStatus === ''">
      该停车场暂无车位信息
    </div>
    <div
      class="pbNum"
      v-else
      :style="'color: ' + statusList[shopInfo.parkingStatus].color"
    >
      车位状态：{{ shopInfo.statusName }}
    </div>
    <div
      :style="
        'margin-top:2px;color: ' + shopInfo.wc == 0
          ? statusList[2].color
          : statusList[0].color
      "
    >
      公共厕所：{{ shopInfo.wc == 0 ? "无" : "有" }}
    </div>
    <div style="margin-top: 10px">
      <div
        style="color: #1bc27d"
        v-if="shopInfo.fastTotal > 0 || shopInfo.trickleTotal > 0"
      >
        充电桩（闲/总）:
      </div>
      <div
        style="margin-top: 10px; display: flex; color: #1bc27d; font-size: 16px"
      >
        <div v-if="shopInfo.fastTotal > 0">快</div>
        <div v-if="shopInfo.fastTotal > 0">
          {{ shopInfo.fastCharge }}/{{ shopInfo.fastTotal }}
        </div>
        <div
          style="margin-left: 10px; color: #3889ff"
          v-if="shopInfo.trickleTotal > 0"
        >
          慢
        </div>
        <div style="color: #3889ff" v-if="shopInfo.trickleTotal > 0">
          {{ shopInfo.trickleCharge }}/{{ shopInfo.trickleTotal }}
        </div>
      </div>
      <div
        style="margin-top: 10px"
        v-if="shopInfo.fastTotal > 0 || shopInfo.trickleTotal > 0"
      >
        充电电价:
        <div style="margin-top: 10px; color: #3889ff; font-size: 16px">
          {{ shopInfo.chargeFee }}100元/度
        </div>

        <div></div>
      </div>
    </div>
  </bm-overlay>
</template>

<script>
import bus from "@/utils/bus";
export default {
  props: ["position", "shopInfo"],
  data() {
    return {
      statusList: [
        { color: "#23BE87", name: "富余" },
        { color: "#1966ff", name: "一般" },
        { color: "#FE464C", name: "紧张" },
      ],
    };
  },
  watch: {
    position: {
      handler() {
        this.$refs.customOverlay.reload();
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    draw({ el, BMap, map }) {
      console.log("{el, BMap, map}", { el, BMap, map });
      const { lng, lat } = this.position;
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
      el.style.left = pixel.x - 60 + "px";
      el.style.top = pixel.y - 20 + "px";
    },
  },
};
</script>

<style>
.sample {
  line-height: 1;
  min-width: 120px;
  padding: 8px 10px;
  color: #000;
  font-size: 12px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  position: absolute;
  transform: translate(calc(-50% + 55px), calc(-100% + -15px));
  /* 55px,-15px 可让该窗口根据P标上方中心点对齐 */
}
.mapGo {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.parkName {
  font-size: 12px;
  /* padding-bottom: ; */
  width: 10em;
  line-height: 1.2;
}
.parkIcon {
  height: 36px;
  padding-left: 4px;
}
.pbNum {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/MyOverlay.vue